module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.listaClassificacoes,
      "search": _vm.search,
      "no-data-text": 'Este projeto não possui classificações.',
      "must-sort": "",
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "items-per-page": _vm.itemsPerPage,
      "footer-props": {
        itemsPerPageText: 'Linhas por página',
        itemsPerPageOptions: _vm.opcoesPaginacao
      }
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sort-by": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "update:sort-desc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "footer.page-text",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n      Mostrando " + _vm._s(pageStart) + " a " + _vm._s(pageStop) + " de " + _vm._s(_vm.listaClassificacoes.length) + " classificações\n    ")]
      }
    }])
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('c-card-footer', {
    attrs: {
      "projeto": this.projeto,
      "extensao": this.extensao,
      "proxima": "ExtensaoProjeto",
      "editar": "EditarClassificacao",
      "nome_editar": "Editar",
      "habilitaBotaoGerarPDFAcao": true,
      "habilitaBotaoFinalizarAcao": true
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d96ba2b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/projeto/projeto-classificacoes-tabela.vue
// module id = 463
// module chunks = 0